class CardCustom extends HTMLElement {
  constructor() {
    super();
    this.flickity = null;
  }

  connectedCallback() {
    this.initSlider();
  }

  initSlider() {
    const slider = this.querySelector('.card-custom--media_slider');
    if (!slider) return;

    if (slider.classList.contains('flickity-enabled')) return;

    let totalItems = parseInt(slider.dataset.slider, 10);
    if (isNaN(totalItems)) {
      totalItems = slider.querySelectorAll('.card-custom--media__item').length;
    }

    if (totalItems <= 1) return;

    this.flickity = new Flickity(slider, {
      cellAlign: 'left',
      prevNextButtons: true,
      pageDots: false
    });
  }
}

if (!customElements.get('card-custom')) {
  customElements.define('card-custom', CardCustom);
}